import { Component, OnInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpService } from 'app/services/http.service';
import jwt_decode from 'jwt-decode';
import { MessageService } from 'primeng/api';

declare var $: any;

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.css']
})
export class ForgotpasswordComponent implements OnInit {

  focus;
  focus1;
  focus2;
  test: number = new Date().getFullYear();
  private toggleButton;
  private sidebarVisible: boolean;
  private nativeElement: Node;
  email: string = '';
  password: string;
  imagenFondo: string;

  constructor(private element: ElementRef, private http: HttpService,
    public router: Router,
    private messageService: MessageService) {
    this.nativeElement = element.nativeElement;
    this.sidebarVisible = false;
  }

  checkFullPageBackgroundImage() {
    var $page = $('.full-page');
    var image_src = $page.data('image');

    let fotos = [
      './assets/img/bg/fondoforgot1.jpg',
      './assets/img/bg/fondoforgot2.jpg',
    ]

    let cantidadFotos = fotos.length

    let rdn = Math.floor(Math.random() * cantidadFotos)
    console.log('cantidadFotos', cantidadFotos);
    console.log('rdn', rdn);

    image_src = fotos[rdn]

    if (image_src !== undefined) {
      var image_container = '<div class="full-page-background" style="background-image: url(' + image_src + ') "/>'
      $page.append(image_container);
    }
  };

  ngOnInit() {
    console.log('Login ngOnInit');

    this.checkFullPageBackgroundImage();
    var body = document.getElementsByTagName('body')[0];
    body.classList.add('login-page');
    var navbar: HTMLElement = this.element.nativeElement;
    this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];

    setTimeout(function () {
      // after 1000 ms we add the class animated to the login/register card
      $('.card').removeClass('card-hidden');
    }, 700)

  }
 
  enviaEmail() {
    console.log('enviaEmail');
    console.log('this.email', this.email);
    this.email = this.email.trim()

    this.http.recuperapasswordService(this.email).subscribe((data: any) => {
      console.log(data);
      this.messageService.add({ severity: 'success', summary: 'Bien!', detail: 'Se envió un email con las instrucciones para la recuperación' });
      this.email = ''
    }, (err => {
      console.log('Error:', err);
      this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error });
      this.password = '';
    }))
  }

  ngOnDestroy() {
    var body = document.getElementsByTagName('body')[0];
    body.classList.remove('login-page');
  }
  sidebarToggle() {
    var toggleButton = this.toggleButton;
    var body = document.getElementsByTagName('body')[0];
    var sidebar = document.getElementsByClassName('navbar-collapse')[0];
    if (this.sidebarVisible == false) {
      setTimeout(function () {
        toggleButton.classList.add('toggled');
      }, 500);
      body.classList.add('nav-open');
      this.sidebarVisible = true;
    } else {
      this.toggleButton.classList.remove('toggled');
      this.sidebarVisible = false;
      body.classList.remove('nav-open');
    }
  }
}
